import { render, staticRenderFns } from "./FederationControlAction.vue?vue&type=template&id=2ef553c8&scoped=true&"
import script from "./FederationControlAction.vue?vue&type=script&lang=js&"
export * from "./FederationControlAction.vue?vue&type=script&lang=js&"
import style0 from "./FederationControlAction.vue?vue&type=style&index=0&id=2ef553c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef553c8",
  null
  
)

export default component.exports